// Falha ao carregar um chunk JS servido pelo Next. A mensagem varia por engine:
//   Chromium/webpack: "Loading chunk 123 failed", name "ChunkLoadError"
//   Next 16:          "Failed to load chunk /_next/static/chunks/<hash>.js from module <id>"
//   WebKit/Safari:    "Importing a module script failed" / "Load failed"
// Quando o chunk pertence a um import dinâmico do layout raiz, o erro sobe acima do boundary de
// página e cai no global-error — site inteiro quebrado. reset() não recupera: re-renderiza com o
// mesmo grafo de módulos; o chunk continua ausente (hash invalidado no deploy). Só um reload de
// documento busca o manifesto novo.
const CHUNK_ERROR_PATTERNS: readonly RegExp[] = [
  /loading chunk [\w-]+ failed/i,
  /failed to load chunk/i,
  /importing a module script failed/i,
  /error loading dynamically imported module/i,
  /^'?load failed'?$/i,
];

export function isChunkLoadError(error: unknown): boolean {
  if (error == null || typeof error !== 'object') return false;
  const err = error as { name?: unknown; message?: unknown };
  if (err.name === 'ChunkLoadError') return true;
  const message = typeof err.message === 'string' ? err.message : '';
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message.trim()));
}

const RELOAD_GUARD_KEY = 'dd_chunk_reload_at';
// Um chunk ausente se resolve com um único reload (o novo HTML referencia os hashes novos). Se o
// erro reincidir dentro desta janela, é sinal de que o reload não resolveu — parar de recarregar e
// mostrar a tela de erro, para não entrar em loop de reload.
const RELOAD_GUARD_WINDOW_MS = 10_000;

type ReloadGuardStorage = Pick<Storage, 'getItem' | 'setItem'>;

// Decide se é seguro auto-recarregar agora, registrando o instante da tentativa. Retorna false
// (sem reload) quando já houve um reload recente — ou quando não há storage confiável para a
// guarda (ex.: Safari privado antigo), caso em que recarregar sem guarda arriscaria loop.
export function shouldReloadForChunkError(
  storage: ReloadGuardStorage | undefined = safeSessionStorage(),
  now: number = Date.now()
): boolean {
  if (!storage) return false;
  try {
    const last = Number(storage.getItem(RELOAD_GUARD_KEY)) || 0;
    if (last > 0 && now - last < RELOAD_GUARD_WINDOW_MS) return false;
    storage.setItem(RELOAD_GUARD_KEY, String(now));
    return true;
  } catch {
    return false;
  }
}

function safeSessionStorage(): ReloadGuardStorage | undefined {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : undefined;
  } catch {
    return undefined;
  }
}
